import { timelineItems } from "@/mocks/profile";

export default function TimelineSection() {
  return (
    <section id="updates" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-10">
          <p className="font-label text-primary-600 text-xs tracking-[0.25em] mb-3">UPDATES / 近况</p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-4">
            关注度是这样一步步起来的
          </h2>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            下面这条时间线按话题走向梳理，从名字开始被搜索，到资料、绯闻、社交动态陆续被讨论。它描述的是讨论热度的变化，
            不代表官方确认的时间信息，具体节点请以权威渠道为准。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-6 lg:gap-8">
          <ol className="relative border-l-2 border-background-300 pl-6 md:pl-8 space-y-8">
            {timelineItems.map((item) => (
              <li key={item.title} className="relative">
                <span className="absolute -left-[34px] md:-left-[42px] top-1 w-5 h-5 flex items-center justify-center rounded-full bg-background-100 border-2 border-accent-500">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                </span>
                <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
                  <span className="inline-block font-label text-[11px] text-accent-700 bg-accent-100 px-2.5 py-1 rounded-full mb-3">
                    {item.period}
                  </span>
                  <h3 className="font-heading font-bold text-foreground-950 text-lg md:text-xl mb-2.5">
                    {item.title}
                  </h3>
                  <p className="text-foreground-700 text-sm md:text-[15px] leading-relaxed">{item.desc}</p>
                </div>
              </li>
            ))}
          </ol>

          <aside className="lg:sticky lg:top-24 h-fit">
            <div className="rounded-lg overflow-hidden border border-background-200 bg-background-50">
              <div className="w-full h-48 md:h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20flowing%20time%20and%20attention%20curves%20in%20warm%20terracotta%20amber%20and%20cream%20tones%2C%20soft%20grain%20texture%2C%20artistic%20editorial%20graphic%20without%20text%2C%20calm%20elegant%20composition&width=800&height=640&seq=saeko-timeline-01&orientation=landscape"
                  alt=""
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-bold text-foreground-950 text-base mb-3 flex items-center gap-2">
                  <i className="ri-lightbulb-flash-line text-accent-600" aria-hidden="true"></i>
                  看这条时间线的小提示
                </h3>
                <ul className="space-y-3 text-sm text-foreground-700 leading-relaxed">
                  <li className="flex gap-2.5">
                    <i className="ri-checkbox-circle-line text-secondary-600 text-base mt-0.5" aria-hidden="true"></i>
                    <span>越靠后的节点，讨论越偏向「近况」而非作品本身。</span>
                  </li>
                  <li className="flex gap-2.5">
                    <i className="ri-checkbox-circle-line text-secondary-600 text-base mt-0.5" aria-hidden="true"></i>
                    <span>标注「说法不一」的地方，说明来源之间互相矛盾。</span>
                  </li>
                  <li className="flex gap-2.5">
                    <i className="ri-checkbox-circle-line text-secondary-600 text-base mt-0.5" aria-hidden="true"></i>
                    <span>热度高不等于事实可靠，两者要分开判断。</span>
                  </li>
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}